import Manager from "@/views/manager/Manager";
import RoleManager from "@/views/manager/RoleManager";
import CompanyManager from "@/views/manager/CompanyManager";
import KpiFormulasManager from "@/views/manager/NewKpiFormula.vue";

export default {
  path: "/manager",
  name: "manager",
  component: Manager,
  meta: {
    auth: true,
    searchable: false,
    title: "Manager",
    tags: ["manager"]
  },
  children: [
    {
      path: "roles",
      name: "manager-role",
      component: RoleManager,
      meta: {
        auth: true,
        index: true,
        title: "Roles",
        searchable: false,
        tags: ["manager", "roles"]
      }
    },
    {
      path: "company",
      name: "manager-company",
      component: CompanyManager,
      meta: {
        auth: true,
        index: true,
        title: "Companies",
        searchable: false,
        tags: ["manager", "company"]
      }
    },
    {
      path: "users",
      name: "manager-users",
      component: () => import("@/views/manager/UserManager.vue"),
      meta: {
        auth: true,
        index: true,
        searchable: false,
        tags: ["manger", "users"]
      }
    },
    {
      path: "kpi-formulas",
      name: "kpi-formulas",
      component: KpiFormulasManager,
      meta: {
        auth: true,
        index: true,
        searchable: false,
        title: "KPI Formulas",
        tags: ["manger", "kpi-formulas"]
      }
    }
  ]
};
